(() => {
  const config = document.getElementById('bundle-purchase-selector-labels');
  if (!config) return;

  let labels;
  try {
    labels = JSON.parse(config.textContent);
    labels.subscribe = labels.subscribe.replace(/&amp;/g, '&');
  } catch {
    return;
  }
  const handles = ['14-in-1-magnesium-gummies', 'apple-cider-vinegar-gummies', 'joint-comfort', 'joint-health', 'daily-digestive-support', 'akkermansia-probiotic-capsules'];
  let scheduled = false;
  const toggleWidgets = new WeakSet();

  function handleToggle(event) {
    const widget = event.currentTarget;
    if (widget.dataset.handle === 'akkermansia-probiotic-capsules' && event.target.closest('select, option, .sls-selling-plan-group-options')) return;
    if (!widget.classList.contains('bundle-purchase-selector')) return;
    const subscription = widget.querySelector('input.sls-option[data-type="subscription"]');
    const option = event.target.closest('.sls-option-container');
    if (option !== subscription?.closest('.sls-option-container')) return;
    if (event.type === 'keydown' && ![' ', 'Enter'].includes(event.key)) return;
    if (event.type === 'click' && !subscription.checked) return;
    const target = widget.querySelector('input.sls-option[data-type="' + (subscription.checked ? 'one_time' : 'subscription') + '"]');
    const label = target?.closest('.sls-option-container').querySelector('.sls-selling-plan-group-name');
    if (!label) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    label.click();
    schedule();
  }

  function refresh() {
    scheduled = false;
    document.querySelectorAll('.sealsubs-target-element.sealsubs-full[data-handle]').forEach(widget => {
      if (!handles.includes(widget.dataset.handle)) return;
      const form = widget.closest('form[action*="/cart/add"]');
      const scope = form?.closest('.shopify-section');
      if (!form || (!form.closest('.mgsp__product-form') && !form.closest('[data-digestive-page]') && !scope?.querySelector('.bundle-selector--acv'))) return;

      const calendarCadence = widget.dataset.handle === 'akkermansia-probiotic-capsules' && Boolean(form.closest('[data-ak-page]'));
      const options = widget.querySelectorAll('.sls-option-container');
      const subscription = widget.querySelector('input.sls-option[data-type="subscription"]');
      const oneTime = widget.querySelector('input.sls-option[data-type="one_time"]');
      const interval = widget.querySelector('select[name="subs_interval"]');
      if (options.length !== 2 || !subscription || !oneTime || !interval || (!interval.disabled && !calendarCadence) ||
        widget.querySelector('.sls-option-container[data-prepaid="true"]') ||
        [...widget.querySelectorAll('.sls-selling-plan-description-content')].some(el => el.textContent.trim())) {
        widget.classList.remove('bundle-purchase-selector');
        widget.querySelector('[role="switch"]')?.setAttribute('role', 'radio');
        widget.querySelector('.bundle-purchase-selector__renewal')?.remove();
        return;
      }

      for (const [input, text] of [[oneTime, labels.one_time], [subscription, labels.subscribe]]) {
        const option = input.closest('.sls-option-container');
        const name = option.querySelector('.sls-selling-plan-group-name');
        if (name?.firstChild?.nodeType === Node.TEXT_NODE && name.firstChild.textContent.trim() !== text) {
          name.firstChild.textContent = text + ' ';
        }
        input.setAttribute('aria-label', text);
        const control = input.closest('[role="radio"], [role="switch"]');
        if (control?.getAttribute('aria-label') !== text) control?.setAttribute('aria-label', text);
        if (input === subscription && control) {
          control.setAttribute('role', 'switch');
          const checked = String(subscription.checked);
          if (control.getAttribute('aria-checked') !== checked) control.setAttribute('aria-checked', checked);
        }
        const badge = option.querySelector('.sls-savings-badge');
        const percent = badge?.textContent.match(/\d+(?:[.,]\d+)?\s*%/)?.[0];
        if (percent && badge.textContent !== '−' + percent) badge.textContent = '−' + percent;
      }

      let renewal = widget.querySelector('.bundle-purchase-selector__renewal');
      if (!renewal) {
        renewal = document.createElement('p');
        renewal.className = 'bundle-purchase-selector__renewal';
        renewal.setAttribute('aria-live', 'polite');
      }
      const choices = widget.querySelector('.sls-purchase-options-container');
      if (renewal.parentElement !== choices) choices.appendChild(renewal);
      if (calendarCadence) interval.setAttribute('aria-label', 'Delivery interval');
      const selectedInterval = interval.selectedOptions[0]?.textContent.trim();
      const normalizedInterval = selectedInterval?.toLowerCase() === 'monthly' ? labels.month : selectedInterval;
      const text = labels.renewal.replace('[interval]', normalizedInterval || '');
      if (renewal.textContent !== text) renewal.textContent = text;
      renewal.hidden = !subscription.checked || !normalizedInterval;
      widget.classList.add('bundle-purchase-selector');
      if (!toggleWidgets.has(widget)) {
        widget.addEventListener('click', handleToggle, true);
        widget.addEventListener('keydown', handleToggle, true);
        toggleWidgets.add(widget);
      }
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-checked', 'disabled'],
  });
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  document.fonts?.ready.then(schedule);
  for (const event of ['sealsubs:subscription_widget_created', 'sealsubs:selling_plan_changed', 'sealsubs:price_update']) {
    document.addEventListener(event, schedule, true);
  }
  schedule();
})();
